"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exponentialBackOff = exports.exponentialBackOffFn = exports.checkHeaderAndBody = void 0;
var lodash_1 = require("lodash");
var provider_1 = require("../provider");
var utils_1 = require("./utils");
var checkHeaderAndBody = function (data, headers) {
    var retryAfter = (data === null || data === void 0 ? void 0 : data.retryAfter) || parseInt(headers['retry-after']);
    var retryLimit = (data === null || data === void 0 ? void 0 : data.retryLimit) || parseInt(headers['retry-limit']);
    var madeUpRetryLimit = retryAfter && !retryLimit ? 1 : retryLimit;
    return {
        retryAfter: retryAfter,
        retryLimit: madeUpRetryLimit,
        rateLimitRemaining: data.rateLimitRemaining ||
            parseInt(headers === null || headers === void 0 ? void 0 : headers['x-ratelimit-remaining']) ||
            0,
        resetAfter: (0, utils_1.getResetTime)(data, headers),
        check: !!retryAfter,
    };
};
exports.checkHeaderAndBody = checkHeaderAndBody;
/**
 *
 * @param status
 * @param numberOfRetries
 * @returns retryAfter - number time in seconds
 * This function is used if no retry after is specified by server. Graceful-js exponential back-off function is
 * inspired by this google example. For more information, see https://cloud.google.com/iot/docs/how-tos/exponential-backoff
 */
var exponentialBackOffFn = function (status, numberOfRetries) {
    if (status !== 429 && status !== 503 && status !== 504) {
        return {
            retryAfter: 0,
        };
    }
    var retryAfter = Math.min((2 ^ (numberOfRetries * 1000)) + getRndInteger(500, 1000), provider_1.maxBackOffTime * 1000);
    if (retryAfter === provider_1.maxBackOffTime * 1000) {
        return {
            retryAfter: 0,
        };
    }
    return { retryAfter: retryAfter / 1000 };
};
exports.exponentialBackOffFn = exponentialBackOffFn;
// used in case of 429 or 5xx errors without retry after headers
var exponentialBackOff = function (status, rateLimitInfoCheck, numberOfRetries, backOffFunc) {
    if (rateLimitInfoCheck) {
        return {
            retryAfter: 0,
        };
    }
    if ((0, lodash_1.isFunction)(backOffFunc) && !provider_1.userExponentialBackOffFn) {
        return backOffFunc(status, numberOfRetries);
    }
    return provider_1.userExponentialBackOffFn
        ? (0, provider_1.userExponentialBackOffFn)(status, numberOfRetries)
        : (0, exports.exponentialBackOffFn)(status, numberOfRetries);
};
exports.exponentialBackOff = exponentialBackOff;
function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}
